import React, { Fragment } from 'react'

import { Card, Grid, Typography } from '@mui/material'

import { Asn } from '../../../interfaces/Asn/Asn'

import { AsnSummary } from './AsnSummary'

import { AsnDisplayState } from './AsnDisplayState'

import { AsnAccordion } from './AsnAccordion'

interface AsnViewerProps {
  element: Asn
  hideInfoReturnAsn?: boolean
}

export const AsnViewer: React.FC<AsnViewerProps> = ({
  element,
  hideInfoReturnAsn
}) => {
  return (
    <Fragment>
      <Card>
        <div>
          <Grid container xs={12} spacing={1} style={{ paddingLeft: '40px' }}>
            <Typography variant='h5'>
              {`ASN ${element.asnNumber} - ${element.supplierName}`}
            </Typography>
          </Grid>
          <hr />
          <Grid
            container
            xs={12}
            spacing={1}
            style={{ paddingLeft: '40px', paddingTop: '10px' }}
          >
            <AsnSummary elementId={element.asnId} />
          </Grid>
          <Grid container xs={12} spacing={1} style={{ paddingLeft: '40px' }}>
            <AsnDisplayState asnStateName={element.asnStateName} />
          </Grid>
          <AsnAccordion
            element={element}
            hideInfoReturnAsn={hideInfoReturnAsn}
          />
        </div>
      </Card>
    </Fragment>
  )
}
